import { Components, Theme } from "@mui/material/styles";

export default {
  MuiButton: {
    defaultProps: {
      disableRipple: true,
      disableElevation: true,
    },
    styleOverrides: {
      root: {
        textTransform: "none" as const,
        height: 35,
        borderRadius: 20,
      },
      // Only outlined buttons get the primary border
      outlined: ({ theme }: { theme: Theme }) => ({
        "&:not([disabled])": {
          border: `1px solid ${theme.palette.primary.main}`,
        },
      }),
    },
  } as Components["MuiButton"],
};
